import { App } from "vue";
import { createLoading, loadingDirective } from "y-design/libs/loading";

import "y-design/packages/loading/src/style.scss";

enum EDirection {
  Forward = "forward",
  Reverse = "reverse",
}

enum ELocation {
  Top = "top",
  Right = "right",
  Bottom = "bottom",
  Left = "left",
  Center = "center",
}

enum EPosition {
  Relative = "relative",
  Absolute = "absolute",
  Fixed = "fixed",
}

interface ILoadingProps {
  color?: string;
  bgColor?: string;
  bgBorderRadius?: string | number;
  thick?: string | number;
  direction?: EDirection;
  size?: string | number;
  padding?: string | number;
  text?: string;
  textLocation?: ELocation;
  textSize?: string | number;
  textColor?: string;
  position?: EPosition;
}

interface IToastParams {
  show(props: ILoadingProps): void;
  hide(): void;
}

export default {
  // provide
  provide(app: App): void {
    app.provide("loading", createLoading);
  },
  // 注册插件及v-loading
  directive(app: App): void {
    app.use(loadingDirective);
  },
  inject(): IToastParams {
    return inject("loading", {
      show: () => null,
      hide: () => null,
    });
  },
};
